<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
    * {
        background: #122512;
        color: rgb(17, 235, 16);
    }
</style>



// WEBPACK FOOTER //
// src/App.vue